/** @format */

const data = {
  Indian: [
    { name: "Dangal Title Track", artist: "Daler Mehndi", rating: "4.5/5" },
    { name: "Andhadhun Title Track ", artist: "Raftaar", rating: "3.5/5" },
    { name: "Sun le re", artist: "Papon", rating: "4.5/5" },
    { name: "Moh Moh ke dhaage", artist: "Monali Thakur", rating: "4/5" },
  ],
  Classical: [
    { name: "Vivaldi", artist: "The Four Seasons", rating: "4.7/5" },
    { name: " Same Old Thing", artist: "The Streets", rating: "4.1/5" },
    { name: "Symphony No.6 ", artist: "Beethoven", rating: "3.6/5" },
    { name: "Bizet", artist: "Carmen", rating: "3.2/5" },
  ],
  Rock: [
    {
      name: "Rockin' in the Free World",
      artist: "Neil Young",
      rating: "2/5",
    },
    { name: "Hey Jude", artist: "The Beatles", rating: "4.5/5" },
    { name: "Stairway To Heaven", artist: " Led Zeppelin", rating: "4.1/5" },
    { name: "Comfortably Numb", artist: "Pink Floyd", rating: "4.4/5" },
  ],
  Blue: [
    { name: "I Cant Quit You Baby", artist: "Otis Rush", rating: "4.6/5" },
    { name: "I’d Rather Go Blind", artist: "Etta James", rating: "4.3/5" },
    { name: "Crossroad Blues", artist: "Robert Johnson", rating: "4.1/5" },
    { name: "Sunshine Of Your Love", artist: "Cream", rating: "3.9/5" },
  ],
  Pop: [
    { name: "Peaches", artist: "Justin Bieber", rating: "4.2/5" },
    { name: "Bad Habits", artist: "Ed Sheeran", rating: "4.1/5" },
    { name: "Levitating", artist: "Dua Lipa", rating: "3.4/5" },
    { name: "Happier than ever", artist: "Billie Eilish", rating: "3.8/5" },
  ],
};

export { data };
// console.log(music["Indian"]);
